/* eslint-disable no-undef */
const EventBus = window.EventBus;
export const Omnisearch = {
  props: {
    results: Array,
    lang: String,
    templatedir: String,
    showvin: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      chosen: "",
      loading: false,
      selected: null,
      model: null,
      initialResultset: [],
    };
  },
  created() {
    this.httpRequestInventory();
  },
  methods: {
    httpRequestInventory() {
      this.loading = true;
      EventBus.httpRequestInventory(
        null,
        this.entryPoint,
        this.gutembergOptions
      );
    },
    entryPoint(inventory) {
      this.loading = false;
      this.initialResultset = this.results;
    },
    onRequestStart() {
      this.loading = true;
    },
    goto(url) {
      window.open(url, "_self").focus();
    },
    onSuggestSelect() {
      if (this && this.model && this.model != null && this.model != undefined) {
        var itemSlug = this.path + this.model.replace(/ /g, "_").toLowerCase();
        this.initialResultset.forEach(($item) => {
          if ($item.title.split("Vin").length > 1) {
            if (
              $item.title.split("Vin")[1].indexOf(this.model) !== -1 &&
              this.model.length > 4
            )
              itemSlug = $item.slug;
          }
        });

        if (this.$refs.suggestComponent.selected != null)
          itemSlug = this.$refs.suggestComponent.selected.slug;

        var payload = {
          event_category: "LBX-SRP",
          event_label: " LBX-" + this.model,
        };
        window.sendGAEvent("LBX-Search", payload);
        // similar behavior as clicking on a link
        jQuery("#search").attr("disabled", "disabled");

        var jlr_script = document.getElementById("shiftdigital-script");

        if (jlr_script != null) {
          sd("dataLayer", {
            typedSearchContent: this.model.replaceAll(" ", "|"),
            events: "typedSearch",
          });
          sd("send");
        }

        window.location.href = itemSlug;
      }
    },
    onRequestDone() {
      this.loading = false;
    },
    onRequestFailed() {
      this.loading = false;
    },
    customFilter(el, value) {
      //console.log(el.title);
      //console.log(value);
      var text = el.title;
      var searchWords =
        value && value.length > 0 ? value.trim().split(" ") : [];
      var total = 0;
      //console.log('INIT TOTAL FOUND: ' + total + ' TOTAL ARRAY: ' + searchWords.length);
      //|| (vehicle.model.toLowerCase().split(' ').join('').indexOf(model.toLowerCase().split(' ').join('')) !== -1)
      // || (vehicle.model.toLowerCase().split('-').join('').indexOf(model.toLowerCase().split('-').join('')) !== -1)
      for (var j = 0; j <= searchWords.length; j++) {
        if (
          text &&
          searchWords &&
          searchWords[j] &&
          (text.toLowerCase().indexOf(searchWords[j].toLowerCase()) !== -1 ||
            text
              .toLowerCase()
              .split(" ")
              .join("")
              .indexOf(searchWords[j].toLowerCase().split(" ").join("")) !==
              -1 ||
            text
              .toLowerCase()
              .split("-")
              .join("")
              .indexOf(searchWords[j].toLowerCase().split("-").join("")) !== -1)
        )
          total++;
      }

      //console.log('TOTAL FOUND: ' + total + ' TOTAL ARRAY: ' + searchWords.length);
      if (total == searchWords.length) {
        return true;
      } else {
        return false;
      }
    },
    onSuggestClick(suggest) {
      //alert( "VALUE SELECTED: " + suggest);
      var payload = {
        event_category: "LBX-SRP",
        event_label: " LBX-" + suggest,
      };
      window.sendGAEvent("LBX-Search", payload);

      // similar behavior as clicking on a link
      window.location.href =
        this.path + suggest.replace(/ /g, "_").toLowerCase();
    },
    simpleSuggestionList() {
      return this.initialResultset;
    },
    format(list) {
      var $filtered = [];
      list.forEach(($item) => {
        var $text;
        if (this.lang == "fr_CA") {
          $text =
            ($item.make ? $item.make + " " : "") +
            ($item.model ? $item.model + " " : "") +
            ($item.productline ? $item.productline + " " : "") +
            ($item.trim ? $item.trim + " " : "") +
            ($item.year ? $item.year + " " : "") +
            ($item.condition ? this.$t($item.condition) + " " : "") +
            ($item.stocknumber ? " Stock #" + $item.stocknumber : "") +
            (this.showvin ? ($item.vin ? " Vin #" + $item.vin : "") : "");
        } else {
          $text =
            ($item.condition ? this.$t($item.condition) + " " : "") +
            ($item.year ? $item.year + " " : "") +
            ($item.make ? $item.make + " " : "") +
            ($item.model ? $item.model + " " : "") +
            ($item.productline ? $item.productline + " " : "") +
            ($item.trim ? $item.trim + " " : "") +
            ($item.stocknumber ? " Stock #" + $item.stocknumber : "") +
            (this.showvin ? ($item.vin ? " Vin #" + $item.vin : "") : "");
        }
        $filtered.push({
          id: $item.id,
          title: $text,
          slug: this.viewSlug($item),
        });
      });
      return $filtered;
    },
    viewSlug(item) {
      let slug = "/view/";
      if (this.lang == "fr_CA") slug = "/vue/";

      return (
        slug +
        item.condition.toLowerCase().replace(/ /g, "-") +
        "-" +
        item.year.toLowerCase().replace(/ /g, "-") +
        "-" +
        item.make.toLowerCase().replace(/ /g, "-") +
        "-" +
        item.model.toLowerCase().replace(/ /g, "-") +
        "-" +
        item.id
      );
    },
  },
  computed: {
    path() {
      if (this.lang == "fr_CA") return "/recherche/filter/";
      else return "/search/filter/";
    },
    gutembergOptions() {
      return {
        year: "all",
        make: "all",
        model: "all",
        trim: "all",
        price: "all",
        mileage: "all",
        type: "all",
        status: "all",
        tags: "all",
        stock: "all",
        filter: true,
        limit: "0",
        sort_by: "year",
        sort_by_condition: "desc",
        flags: "none",
        layout: "normal",
        location: "all",
      };
    },
  },
};
